import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskRelatedServiceRequestsReducer(state = initialState.taskRelatedServiceRequests, action) {
	switch (action.type) {
		case types.GET_TASK_RELATED_REQUESTS:
			{
				let taskRelatedRequests = action.response;
				if (taskRelatedRequests) return {...taskRelatedRequests};
			}
			break;
		case types.RESET_TASK_RELATED_REQUESTS:
			return {};
		case types.RESET_TASK_DETAIL:
			return {};
		case types.RESET_TASK_ATTRIBUTES:
			return {};
		default:
			return state;
	}
}
